import { IRestTypeIds } from '@fr/vue/components/filters/restTypeFilter/types';

export default function (ids: number[]): IRestTypeIds[] {
    if (!ids) return [];
    const restTypeIds = [1, 2, 3, 4, 11]; // 1 - Пляжный 2 - Городской 3 - Горный/Горнолыжный 4 - Оздоровительный 11 - Загородный/Экологичный
    return ids.filter((id) => restTypeIds.indexOf(id) !== -1) as IRestTypeIds[];
}